var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColoredFlyingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3337 13.3332V11.6665L11.2503 7.49984V2.9165C11.2503 2.22484 10.692 1.6665 10.0003 1.6665C9.30866 1.6665 8.75033 2.22484 8.75033 2.9165V7.49984L1.66699 11.6665V13.3332L8.75033 11.2498V15.8332L6.66699 17.0832V18.3332L10.0003 17.4998L13.3337 18.3332V17.0832L11.2503 15.8332V11.2498L18.3337 13.3332Z",
    fill: "#3D81FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColoredFlyingIcon);
export default __webpack_public_path__ + "static/media/colored-flying-icon.de947719578927336435fd9330a3106b.svg";
export { ForwardRef as ReactComponent };